import React, { Fragment } from "react";
import { Grid } from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import { ReactSVG } from "react-svg";
import styles from "./webinar.module.scss";
import { WebnerForm } from "./components";

export const AustraliaAdmissionDayPage = () => {
  return (
    <Fragment>
      <section className={styles.section_hero}>
        <div className="container">
          <Grid container spacing={{ xs: 3, sm: 3, md: 6 }} alignItems="center">
            <Grid item xs={12} sm={12} md={6}>
              <div className={styles.heading_wrapper}>
                <h1 className={`${styles.heading}`}>
                  Australia
                  <span className={"mark color-orange"}> Admission Day</span>
                </h1>
                <h5 className={styles.sub_heading}>
                  30-minute, one-to-one sessions for each student
                </h5>
                <p className={`${styles.sub_text} `}>
                  UniSearch revolves around our firm commitment to ensuring
                  every student has access to their ideal study abroad
                  solutions. Our Australia Admission Day event is built on this
                  philosophy - we aim to connect with you, directly, and build
                  personalised solutions that turn your study abroad dreams into
                  reality.
                </p>

                <div className={styles.time_wrapper}>
                  <div className={styles.time_card}>
                    <ReactSVG
                      src={getAssets("assets/images/webinar/calendar.svg")}
                    />
                    <div className={styles.time_text}>
                      <div className={styles.time_text_bold}>Date</div>
                      <div className={styles.time_text_normal}>
                        18<sup>th</sup> June, Saturday, 2022
                      </div>
                    </div>
                  </div>
                  <div className={styles.time_card}>
                    <ReactSVG
                      src={getAssets("assets/images/webinar/stopwatch.svg")}
                    />
                    <div className={styles.time_text}>
                      <div className={styles.time_text_bold}>Time</div>
                      <div className={styles.time_text_normal}>
                        10:30 am to 4:30 pm
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.btn_wrapper}>
                  <a href={"#form"} className={`btn btn-secondary btn-bg`}>
                    Book Now
                  </a>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div className={styles.hero_image_wrapper}>
                <img
                  src={getAssets(
                    "assets/images/webinar/webinar-australia-admission-day.png"
                  )}
                  alt="Australia Admission Day"
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </section>

      {/* Section Description */}
      <div className={styles.description_and_form_section_wrapper}>
        <section>
          <div className="container">
            <div className={styles.description_wrapper}>
              <div className={styles.description_title_wrapper}>
                <h4 className={styles.description_sub_title}>
                  Bring your academic documents for a full profile evaluation!
                </h4>
                <h2 className={styles.description_title}>
                  During the{" "}
                  <span className={"color-orange"}>
                    UniSearch Australia Admission Day,{" "}
                  </span>{" "}
                  you can:
                </h2>
              </div>
              <div className={styles.description_card_wrapper}>
                <div className={styles.description_card_segment}>
                  <div className={`${styles.description_card} ${styles.red}`}>
                    <ReactSVG
                      src={getAssets(
                        "assets/images/webinar/communications.svg"
                      )}
                    />

                    <div className={styles.description_card_text}>
                      Engage one-to-one in a 30-minute session with our study
                      abroad experts
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.description_card_segment} ${styles.align_top}`}
                >
                  <div className={`${styles.description_card} ${styles.blue}`}>
                    <ReactSVG
                      src={getAssets("assets/images/webinar/education.svg")}
                    />

                    <div className={styles.description_card_text}>
                      Explore the opportunities to study abroad in Australia
                    </div>
                  </div>
                  <div
                    className={`${styles.description_card} ${styles.orange}`}
                  >
                    <ReactSVG
                      src={getAssets("assets/images/webinar/list.svg")}
                    />

                    <div className={styles.description_card_text}>
                      Request a tailored shortlist of programs and universities
                      matching your profile
                    </div>
                  </div>
                </div>
                <div className={styles.description_card_segment}>
                  <div
                    className={`${styles.description_card} ${styles.violet}`}
                  >
                    <ReactSVG
                      src={getAssets("assets/images/webinar/job-search.svg")}
                    />

                    <div className={styles.description_card_text}>
                      Receive a full student profile evaluation
                    </div>
                  </div>
                  <div className={`${styles.description_card} ${styles.green}`}>
                    <ReactSVG
                      src={getAssets("assets/images/webinar/confused.svg")}
                    />

                    <div className={styles.description_card_text}>
                      Clear doubts and inquire about the full study abroad
                      process
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section form */}
        <WebnerForm
          title="Sign Up for the UniSearch Australia Admission Day"
          subTitle="Interested in exploring your options to study abroad in the Australia? Share your details with us below, and we will be in touch with you shortly!"
          subject={"Australia Admission Day"}
          subjectHTML={`
            <div
              style="
                font-size: 22px;
                font-weight: 600;
                line-height: 36px;
                padding: 0 50px;
                text-align: center;
                margin: 0 !important;
              "
            >
            Your Registration Was Successful! | UniSearch <span style="color: #f47f20">Australia Admission Day</span>
            </div>
        `}
          bodyHTML={`
            <div style="padding: 0 50px; font-size: 12px">
              <p style="line-height: 1.8">Hi --NAME--,</p>
              <p style="line-height: 1.8">
               Thank you for signing up for the UniSearch Australia Admission Day! 
              </p>
              <p style="line-height: 1.8">
              Ensuring that the right study abroad solution is accessible for every student, every step of the way is a core commitment for UniSearch. This campaign is part of our efforts to ensure we match you to the best available opportunities out there to make your study abroad dreams come true!
              </p>
              <p style="line-height: 1.8">
              We look forward to seeing you on<br/>
              <span style="font-weight:bold; font-size:13px; line-height:1.4;">June 18th, 2022
              <br/>10:30 a.m. - 4:30 p.m.
              </span>
              </p>
              <p style="line-height: 1.8">
              A UniSearch representative will be in touch with you shortly to book your preferred appointment time.
              </p>
              <p style="line-height: 1.8">
                Warmly, <br />
                UniSearch
              </p>
            </div>
        `}
        />
      </div>
    </Fragment>
  );
};

export default AustraliaAdmissionDayPage;
